
<template>
  <div id="uploadseinzel">
      <PublicMenutop></PublicMenutop>
      <div class="row container" role="main">
        <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">

          <div class="jumbotron">
            <h1>Uploads für {{ uploader_upper_first() }}</h1>
            <br>
            <a href="/frontend/#/public/statistik">
              <button type="button" class="btn btn-primary" style="padding:10px;">Alle Uploader ansehen...</button>
            </a>
          </div>

          <!-- einfache Liniengrafik -->
          <highcharts :options="chartOptions"></highcharts>

          <div v-for="(einmonat,meinindex2) in uploads_fuer_einzelne_monate" :key="meinindex2">
            <h2>{{ einmonat.jahr_monat }}</h2>

            <div v-if="einmonat.einzeln == 0">
              In diesem Monat sind keine Covers angekommen.
            </div>

            <table class="table table-striped">
            <tbody>
              <tr v-for="(zeile,meinindex3) in einmonat.einzeln" :key="meinindex3">
                <td v-for="(spalte,meinindex4) in zeile" :key="meinindex4">

                  <figure class="figure">
                  <a v-bind:href="spalte.link_zur_buecherei_anhand_ean">
                    <img v-bind:src="spalte.bild_url[bildbreite]">
                  </a><br>
                  <figcaption class="figure-caption">Klick auf das Bild -> Bücherei</figcaption>
                  </figure>
                  <br>
                  EAN {{spalte.ean}}<br>
                  Freigabe am {{ spalte.freigabe_ts.replace(/(\d+)\-(\d+)\-(\d+).*$/, "$3.$2.$1") }}    
                </td>
              </tr>
            </tbody>
            </table>
          </div>


          <br>
          <br>
          <br>

        </div>

        <!-- diese Spalte nicht anzeigen wenn Breite kleiner als lg -->
        <!-- https://stackoverflow.com/questions/35351353/missing-visible-and-hidden-in-bootstrap-v4/50558711#50558711 -->
        <div class="col-lg-3 d-none d-lg-block">
          
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-oben.png">
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-mitte-wein.png">
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-mitte-spinne.png">
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-unten.png">
          


          
        </div>
      </div>
      
      <Footer></Footer>
  </div>
</template>

<script>
import PublicMenutop from '../../components/public/PublicMenutop.vue';
import Footer from '../../components/Footer.vue';
// kommt von pinegrow/bootstrap4:
import '../../components/sticky-footer-navbar.css';
import axios from 'axios';
import _ from 'lodash';
import {Chart} from 'highcharts-vue'

// Mixin fuer diese Komponente importieren
import commonvars from '../mixins/commonvars.js';

export default {
  name: 'uploadseinzeln',
  components: {
    PublicMenutop,
    Footer,
    highcharts: Chart
  },
  data() {
    return {
      uploader: this.$route.params.uploader,
      statistik_ueber_monate: [],
      uploads_fuer_einzelne_monate: [],
      // bildbreite kann sein: 90|200
      bildbreite: 200,
      anzahl_monate_zurueck: 6,
      chartOptions: {
        title: {
          text: ""
        },

        yAxis: {
            title: {
                text: 'Anzahl der Covers'
            }
        },
        series: [{
          name: "Uploads",
          data: []
        }]
      }
    }
  },
  watch: {
    // eslint-disable-next-line
    $route(to, from) {
      this.uploader = to.params.uploader; 
    }
  },
  mounted: function() {
    this.hole_alle_uploads_fuer_uploader();
  },
  mixins: [
    commonvars
  ],
  methods: {
    uploader_upper_first() {
      return _.upperFirst(this.uploader);
    },
    hole_alle_uploads_fuer_uploader() {
      let statistik_url = this.api_alle_uploads_fuer_uploader();
      console.log("statistik wurde angefordert, url " + statistik_url);
      axios.get(statistik_url)
          .then(
              response => {
                  // console.log(response.data);
                  this.statistik_ueber_monate = response.data.statistik;

                  // Die Upload*zahlen* der letzten Monate 
                  let uploadzahlen = [];
                  for (let i = 0; i < response.data.statistik.length; i++) {
                    uploadzahlen.push(response.data.statistik[i][1]);
                  }
                  this.chartOptions.series[0].data = uploadzahlen;

                  // Die Upload*monate* = Beschriftung der X-Achse
                  let monats_bez = [];
                  for (let i = 0; i < response.data.statistik.length; i++) {
                    monats_bez.push(response.data.statistik[i][0]);
                  }
                  this.chartOptions.xAxis = {
                    categories: monats_bez
                  };

                  this.chartOptions.title.text = "Coveruploads der letzten " + this.anzahl_monate_zurueck + " Monate";
                  
                  // Aufteilen der Bilder in jeweils 3 pro Reihe
                  this.uploads_fuer_einzelne_monate = _.reverse(response.data.alle_uploads);

                  for (var mindex=0; mindex < this.uploads_fuer_einzelne_monate.length; mindex++ ) {
                    this.uploads_fuer_einzelne_monate[mindex].einzeln = 
                      _.chunk(this.uploads_fuer_einzelne_monate[mindex].einzeln, 3);
                  }
              }
          );
    },
    api_alle_uploads_fuer_uploader() {
        return this.server_base_url() + '/api/uploads/uploader/' + this.uploader 
          +  '/monate/' + this.anzahl_monate_zurueck;
    }
  }
}

</script>

<style scoped>

.jumbotron {    
    background-color: #79ac2921;
}

.table-striped tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, 0.03);
}


</style>


